import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSocket, CONN_STATE } from '../context/SocketContext';
import { useI18n, LANGS } from '../i18n';
import axios from 'axios';

export default function Navbar() {
  const { user, logout } = useAuth();
  const { connState, reconnectAttempt } = useSocket();
  const { lang, setLanguage, t } = useI18n();
  const [friendReqCount, setFriendReqCount] = useState(0);
  useEffect(() => {
    var check = function(){
      var t = localStorage.getItem('token');
      if(!t) return;
      axios.get('/api/friends/requests', {headers:{Authorization:'Bearer '+t}}).then(function(r){setFriendReqCount(r.data.length||0);}).catch(function(){});
    };
    check();
    var iv = setInterval(check, 15000);
    return function(){clearInterval(iv)};
  }, [user]);
  const navigate = useNavigate();
  const [membership, setMembership] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);

  const STATUS_CONFIG = {
    [CONN_STATE.CONNECTED]: { dot:'online', label:t('connConnected') },
    [CONN_STATE.DISCONNECTED]: { dot:'offline', label:t('connDisconnected') },
    [CONN_STATE.RECONNECTING]: { dot:'reconnecting', label:t('connReconnecting') },
  };
  const status = STATUS_CONFIG[connState] || STATUS_CONFIG[CONN_STATE.DISCONNECTED];

  useEffect(() => {
    if (user) axios.get('/api/membership/status').then(r => setMembership(r.data)).catch(() => {});
  }, [user]);

  const handleLogout = () => { logout(); navigate('/login'); };

  const currentLang = LANGS.find(l => l.code === lang) || LANGS[0];

  return (
    <>
      <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <span className="brand-icon">🌍</span>
        <span className="brand-text">Global Heart</span>
      </Link>
      <div className="navbar-right">
        {/* 语言切换 */}
        <div style={{position:'relative',display:'inline-block'}}>
          <button
            className="lang-switch-btn"
            onClick={() => setLangOpen(!langOpen)}
            style={{
              background:'transparent',border:'1px solid rgba(255,255,255,0.2)',borderRadius:16,
              padding:'4px 12px',fontSize:'0.8rem',color:'var(--text-dim)',cursor:'pointer',
              display:'flex',alignItems:'center',gap:4
            }}
          >
            <span>{currentLang.flag}</span>
            <span>{currentLang.label}</span>
            <span style={{fontSize:'0.6rem'}}>▾</span>
          </button>
          {langOpen && (
            <div style={{
              position:'absolute',right:0,top:'calc(100% + 6px)',background:'#1a1a2e',
              border:'1px solid #2a2a3e',borderRadius:10,padding:'6px',zIndex:100,
              boxShadow:'0 8px 24px rgba(0,0,0,0.4)',minWidth:130
            }}>
              {LANGS.map(l => (
                <button
                  key={l.code}
                  onClick={() => { setLanguage(l.code); setLangOpen(false); }}
                  style={{
                    display:'flex',alignItems:'center',gap:8,width:'100%',padding:'8px 10px',
                    background: lang === l.code ? 'rgba(79,124,255,0.15)' : 'transparent',
                    border:'none',borderRadius:6,cursor:'pointer',fontSize:'0.85rem',
                    color: lang === l.code ? '#4f7cff' : '#ddd',textAlign:'left'
                  }}
                >
                  <span>{l.flag}</span><span>{l.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        {/* 会员状态 */}
        {user && membership && (
          <Link to="/pricing" className={`nav-badge ${membership.tier}`}>
            {membership.badge || '🆓'}
            <span className="nav-tier-label">{membership.label}</span>
          </Link>
        )}

        {/* 连接状态 */}
        <div className="conn-indicator" title={`${t('connectionStatus')}: ${status.label}`}>
          <span className={`conn-dot ${status.dot}`} />
          <span className="conn-label">{status.label}</span>
          {connState === CONN_STATE.RECONNECTING && reconnectAttempt > 0 && (
            <span className="conn-attempt">#{reconnectAttempt}</span>
          )}
        </div>

        
      </div>
    
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? "✕" : "☰"}</button>
      </nav>
      {menuOpen && (
        <div className="menu-dropdown" onClick={() => setMenuOpen(false)}>
          <div className="menu-header">
            {user ? (
              <>
                <span className="menu-avatar">{user.username?.charAt(0)?.toUpperCase() || "?"}</span>
                <span className="menu-username">{user.username}</span>
              </>
            ) : (
              <span className="menu-username">{t('notLoggedIn')}</span>
            )}
          </div>
          <div className="menu-links">
            <Link to="/discover" className="menu-link">🌐 {t('navDiscover')}</Link>
            <Link to="/community" className="menu-link">💬 {t('navCommunity')}</Link>
            <Link to="/friends" className="menu-link">👥 {t('navFriends')}{friendReqCount > 0 && <span style={{background:"#ef4444",color:"#fff",fontSize:"0.65rem",width:18,height:18,borderRadius:"50%",display:"inline-flex",alignItems:"center",justifyContent:"center",marginLeft:4,fontWeight:700}}>{friendReqCount}</span>}</Link>
            <Link to="/moments" className="menu-link">✨ {t('navMoments')}</Link>
            <Link to="/pricing" className="menu-link">💎 {t('navPricing')}</Link>
            <Link to="/marketplace" className="menu-link">🛒 {t('navShop')}</Link>
            <Link to="/marketplace/orders" className="menu-link">📦 {t('ordersTitle')}</Link>
            <Link to="/shop" className="menu-link">🏪 {t('shop')}</Link>
            <Link to="/download" className="menu-link">📲 {t('download')}</Link>
            {user && user.username === "jack" && <Link to="/admin" className="menu-link">📊 {t('admin')}</Link>}
            {user && <Link to={"/profile/"+user.id} className="menu-link">👤 {t('navProfile')}</Link>}
          </div>
          {user && (
            <div className="menu-footer">
              <button className="btn-logout menu-logout" onClick={handleLogout}>🚪 {t('logout')}</button>
            </div>
          )}
        </div>
      )}
    </>
  );
}
